module.exports = __webpack_public_path__ + "static/img/boxing.57556c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/BoxingCamp/img/shake/boxing.png
// module id = 488
// module chunks = 0